pageId = 'page-brohao-success'
page = '#' + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $link = $page.find('.btn-save-ticket')
  return unless $link.length
  content = """
    #{ $page.find('.page-title')[0].innerText }\n
    #{ $('#ticket-desc')[0].innerText }\n
    #{ $('#ticket-content')[0].innerText }
    #{ $page.find('.dd-cipher')[0].title }
  """.replace(/\n/g, '\r\n')
  href = "data:text/plain;charset=utf-8,\ufeff#{encodeURIComponent content}"
  $link.attr('href', href)

